/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Isbaserole2Inputs */

const en_entity_isbaserole2 = /** @type {(inputs: Entity_Isbaserole2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is Base Role`)
};

const de_entity_isbaserole2 = /** @type {(inputs: Entity_Isbaserole2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ist Basisrolle`)
};

/**
* | output |
* | --- |
* | "Is Base Role" |
*
* @param {Entity_Isbaserole2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_isbaserole2 = /** @type {((inputs?: Entity_Isbaserole2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Isbaserole2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_isbaserole2(inputs)
	return de_entity_isbaserole2(inputs)
});
export { entity_isbaserole2 as "entity_isBaseRole" }